import type { PrivyClientConfig } from '@privy-io/react-auth'
import { chain } from './chain'

export const appId = import.meta.env.VITE_PRIVY_APP_ID
export const privyConfig: PrivyClientConfig = {
  appearance: {
    theme: 'light',
    landingHeader: 'ARCS Wallet',
    loginMessage: '以下の認証方法を利用してログインしてください',
  },
  defaultChain: chain,
  embeddedWallets: {
    ethereum: {
      createOnLogin: 'users-without-wallets',
    },
    // トランザクション署名時にPrivyのビルトインモーダルを表示しない
    // 代わりに独自のConfirmationModalを使用する
    showWalletUIs: false,
  },
  loginMethods: ['google', 'twitter', 'email'],
}

/**
 * cross-app whitelabel ページ(/cross-app/*)専用の Privy 設定。
 * requester(ARCS Prime Pool・海外向け/ダーク基調)に合わせ、Privy ログインモーダルを
 * **英語＋ダークテーマ**にする。メインアプリ(privyConfig)には影響しない。
 */
export const crossAppPrivyConfig: PrivyClientConfig = {
  ...privyConfig,
  appearance: {
    ...privyConfig.appearance,
    theme: 'dark',
    accentColor: '#5b8def',
    loginMessage: 'Choose a login method to continue',
  },
}
